import { api } from './api.js';

export const monthLabel = (month) =>
  new Date(`${month}-01T00:00:00Z`).toLocaleDateString('en-GB', {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  });

export const fmtStamp = (value) =>
  new Date(value).toLocaleString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

const monthOf = (date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;

export const thisMonth = (sourceMonth) => sourceMonth || monthOf(new Date());

export function recentMonths(count = 12, sourceMonth) {
  const [year, month] = thisMonth(sourceMonth).split('-').map(Number);
  return Array.from({ length: count }, (_, i) =>
    monthOf(new Date(year, month - 1 - i, 1)),
  );
}

export function monthOptions(selected, count = 12, sourceMonth) {
  const months = recentMonths(count, sourceMonth);
  if (!selected || months.includes(selected)) return months;
  return [...months, selected].sort().reverse();
}

export async function runUsageJob(path, body, { interval = 2000 } = {}) {
  let { job } = await api(path, {
    method: 'POST',
    body: JSON.stringify(body),
  });
  const giveUpAt = Date.now() + 20 * 60 * 1000;
  while (job.status === 'queued' || job.status === 'running') {
    if (Date.now() > giveUpAt)
      throw new Error('Still recomputing on the server — check back later.');
    await new Promise((resolve) => setTimeout(resolve, interval));
    ({ job } = await api(`/usage/jobs/${job.id}`));
  }
  if (job.status === 'failed') throw new Error(job.error || 'Recompute failed');
  return job.result;
}
